import Issue from './issue';

export default Issue;